import {
  animate,
  state,
  style,
  transition,
  trigger,
} from "@angular/animations";
import { Component, Input, OnInit } from "@angular/core";
import { AppyUser } from "src/app/core/model/v2/AppyUser";
import {
  UserCheckout,
  UsersGroupedByCategory,
} from "src/app/core/model/v2/practice/RoleGroupedUser";

@Component({
  selector: "app-setup-RoleGroupCheckout",
  templateUrl: "./setup-RoleGroupCheckout.component.html",
  styleUrls: ["./setup-RoleGroupCheckout.component.scss"],
})
export class SetupRoleGroupCheckoutComponent implements OnInit {
  @Input() groupRole: UsersGroupedByCategory;

  constructor() {}

  ngOnInit() {}

  getUserStatus(user: UserCheckout) {
    if (!user.alreadyCharged && user.practitionerName) {
      return "[ Pending Activation ]";
    }
    return "";
  }
}
